export const languageIds = {
  norwegian: 'lang_no',
  danish: 'lang_dk',
  finnish: 'lang_fi',
  swedish: 'lang_se',
  english: 'lang_en'
}

// checkLanguage :: string => iimclient => boolean
export const checkLanguage = language => client => client.lang === languageIds[language];

// is<lang> :: iimclient => boolean
export const [
  isNorwegian,
  isDanish,
  isFinnish,
  isSwedish,
  isEnglish
] = [
  'norwegian',
  'danish',
  'finnish',
  'swedish',
  'english'
].map(checkLanguage)

// getTranslation :: (string, object) => string | undefined (undefined only if the language doesn't exist in the translations dictionary)
export const getTranslation = (lang, dict) => dict[lang] || dict[languageIds.norwegian] // (default to no as was the practice before)